import { homeCommonConfig } from './common'
import type { HomePageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

const primaryGradient = 'linear-gradient(90deg, #A66BFF 0%, #8E47FF 100%)'

export const theme = {
  homeBg: '',
  tagsBg: '',
  tagActiveBg: brandTheme.primaryColor,
  tagActiveText: brandTheme.textInverse,
  tagInactiveBg: '#332247',
  tagInactiveText: 'rgba(240, 234, 250, 0.72)',
  tabActiveGradient: `linear-gradient(270deg, ${brandTheme.bgGlobal} 0%, ${brandTheme.primaryColor} 95%)`,
  tabActiveColor: brandTheme.textPrimary,
  stickyHeaderBg: brandTheme.bgGlobal,
  primaryGradient,
  tabBorderColor: 'rgba(255, 255, 255, 0.08)',
  tabBackground: 'rgba(255, 255, 255, 0.03)',
  tabTextColor: 'rgba(240, 234, 250, 0.72)',
  tabActiveBorderColor: 'rgba(166, 107, 255, 0.25)',
  tabActiveBackground: 'rgba(166, 107, 255, 0.14)',
  headerIconColor: 'rgba(240, 234, 250, 0.88)',
  isStorlyn: true,
} as const

export const homeConfig: HomePageConfig = {
  theme,
  texts: homeCommonConfig.texts,
}
